var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex gap-2 align-items-center"},[_c('i',{staticClass:"float-end input-tooltip-btn",class:{
      'icon-outline_info': !_vm.isHover,
      'icon-fill_info': _vm.isHover,
    },attrs:{"id":`${_vm.id}-tooltip`},on:{"mouseenter":function($event){_vm.isHover = true},"mouseleave":function($event){_vm.isHover = false}}}),_c('b-tooltip',{attrs:{"target":`${_vm.id}-tooltip`,"triggers":"hover","placement":_vm.placement}},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }